// ------------------------------------------------------------
// * APP_CONFIG is a configuration object for the application.
// * It contains the configuration for the API, file upload, and other settings.
// ------------------------------------------------------------
export const APP_CONFIG = {
  // API Configuration
  API: {
    TIMEOUT: 60000, // 1 minute timeout
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000,
  },
  
  // File Upload Configuration
  FILE_UPLOAD: {
    MAX_SIZE: 100 * 1024 * 1024, // 100MB
    MAX_VIDEO_DURATION: 360, // 6 minutes
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    ALLOWED_VIDEO_TYPES: ['video/mp4', 'video/webm', 'video/ogg'],
    ALLOWED_DOCUMENT_TYPES: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
      'text/plain',
      'text/csv',
      'application/rtf',
      'application/vnd.oasis.opendocument.text', // .odt
      'application/vnd.oasis.opendocument.spreadsheet', // .ods
      'application/vnd.oasis.opendocument.presentation', // .odp
    ] as const,
  },
} as const;
